import { useState, useCallback } from 'react';
import { services } from '../../../context';
import { AccountPayload } from '@v2/types';

interface UseCreateAccountResult {
  createAccount: (data: AccountPayload) => Promise<string | null>;
  loading: boolean;
  error: string | null;
}

export const useCreateAccount = (): UseCreateAccountResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createAccount = useCallback(async (data: AccountPayload): Promise<string | null> => {
    setLoading(true);
    setError(null);

    try {
      const axiosInstance = services.axios.Axios();
      const response = await axiosInstance.post<string>('accounts', data);
      return response.data;
    } catch (err: unknown) {
      setError('Failed to create account');
      console.error('Error creating account:', err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    createAccount,
    loading,
    error,
  };
};

export default useCreateAccount;
